import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import Cookies from "js-cookie";
import { all_routes } from "../../../../router/all_routes";
import { useUserPermissions } from "../../../../UserPermissionsContext";


const PrismImportData = () => {
  const routes = all_routes;
  const navigate = useNavigate();

  const jwtToken = Cookies.get("authToken");
  const { userPermissions, webApi } = useUserPermissions();
  const [isLoading, setIsLoading] = useState(false);
  const [excelFile, setExcelFile] = useState<File | null>(null);


  const checkPermission = (action: any, subject: any) => {
    return userPermissions.some(
      (ability) => ability.action === action && ability.subject === subject
    );
  };



  const options = {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${jwtToken}`,
    },
  };


  useEffect(() => {
    if (!checkPermission("upload_infinityteacherlogimdata", "infinityteacherlogimdata")) {
      navigate(routes.crmLandingPage);
    } else {
    }
  }, [userPermissions]);

  useEffect(() => {
    const forms = document.querySelectorAll(
      ".needs-validation"
    ) as NodeListOf<HTMLFormElement>;
    Array.from(forms).forEach((form) => {
      form.addEventListener(
        "submit",
        (event) => {
          if (!form.checkValidity()) {
            event.preventDefault();
            event.stopPropagation();
          }
          form.classList.add("was-validated");
        },
        false
      );
    });
  }, []);

  const convertToCSV = (data: any[]) => {
    if (data.length === 0) return "";

    const headers = Object.keys(data[0]).join(",");
    const rows = data.map((row) =>
      Object.values(row)
        .map((value) => `"${value}"`)
        .join(",")
    );

    return [headers, ...rows].join("\n");
  };


  const downloadCSV = (csvData: string, filename: string) => {
    const blob = new Blob([csvData], { type: "text/csv;charset=utf-8;" });
    const url = URL.createObjectURL(blob);

    const link = document.createElement("a");
    link.href = url;
    link.setAttribute("download", filename);

    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
  e.preventDefault();

  if (!excelFile) {
    alert("Please upload an Excel file.");
    return;
  }

  setIsLoading(true);

  try {
    const formData = new FormData();
    formData.append("file", excelFile);

    const response = await fetch(
      `${webApi}/school_leads/import_school_leads_data/`,
      {
        method: "POST",
        headers: {
          Authorization: `Bearer ${jwtToken}`,
        },
        body: formData,
      }
    );

    if (!response.ok) {
      const errText = await response.text();
      console.error("Server Error:", errText);
      throw new Error("Upload failed");
    }

    // Read CSV text directly
    const csvText = await response.text();

    // Download CSV directly
    const blob = new Blob([csvText], { type: "text/csv;charset=utf-8;" });
    const url = URL.createObjectURL(blob);

    const link = document.createElement("a");
    link.href = url;
    link.setAttribute("download", "prism_uploaded_leads.csv");
    document.body.appendChild(link);
    link.click();
    link.remove();
    navigate(routes.prismPendingLeads);
  } catch (err) {
    console.error("UPLOAD ERROR:", err);
  } finally {
    setIsLoading(false);
  }
};



  return (
    <div>
      <div className="page-wrapper">
        <div className="content container-fluid">
          <div className="page-header">
            <div className="row">
              <div className="col-sm-12">
                <h3 className="page-title">Prism Leads Upload</h3>
                <ul className="breadcrumb">
                  {/* <li className="breadcrumb-item">
                    <Link to={routes.employeeDashboard}>Dashboard</Link>
                  </li> */}
                  <li className="breadcrumb-item active">Prism Leads Upload</li>
                </ul>
              </div>
            </div>
          </div>

          <div className="row justify-content-center">
            <div className="col-sm-12 d-flex justify-content-center">
              <div
                className="card"
                style={{
                  width: "70%",
                  boxShadow: "0 4px 8px 0 rgba(0,0,0,0.2)",
                  borderRadius: "10px",
                }}
              >
                <div className="card-body">
                  <form onSubmit={handleSubmit} className="d-flex flex-column">
                    <div className="mb-3">
                      <label className="form-label">Upload Excel File</label>
                      <input
                        type="file"
                        accept=".xlsx,.xls"
                        className="form-control"
                        required
                        onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
                          if (e.target.files && e.target.files.length > 0) {
                            setExcelFile(e.target.files[0]);
                          }
                        }}
                      />
                      <div className="invalid-feedback">Please upload an Excel file.</div>
                    </div>


                    <div className="modal-footer">
                      <Link
                        className="btn btn-primary"
                        type="submit"
                        to={routes.wizklubCategories}
                        style={{
                          backgroundColor: "lightcoral",
                          color: "white",
                          marginRight: "5px",
                        }}
                      >
                        Cancel
                      </Link>
                      <button
                        className="btn btn-primary"
                        type="submit"
                        disabled={isLoading}
                      >
                        {isLoading ? (
                          <i className="spinner-border spinner-border-sm"></i>
                        ) : (
                          <>Save</>
                        )}
                      </button>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PrismImportData;
